import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';

@Component({
  selector: 'app-participant-detail',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `<div class="tw-flex tw-gap-8">
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="User ID" name="userId" labelCase="none" />
        <app-detail-item label="Name 2" name="name2" />
        <app-detail-item label="Comment" name="comment" />
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Attention To" name="attentionTo" />
        <app-detail-item label="Role Type" name="roleType" />
        <app-detail-item label="DBA" name="dba" labelCase="none" />
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="SIC Code" name="sicCode" labelCase="none" />
        <app-detail-item label="FEIN" name="fein" labelCase="none" />
      </app-detail-panel>
    </div>
  </div>`,
  styles: [],
})
export class ParticipantDetailComponent {
  @Input() dataSource: any;
}
